import graphQLClient from "src/graphQL";
import { clients } from "src/queries/clients";

export const getDataClient = async () => {
  const response = await graphQLClient.query({
    query: clients,
    variables: {
      where: { id: "me" },
    },
    errorPolicy: "all",
    fetchPolicy: "no-cache",
  });

  const client = response.data.clients ? response.data.clients[0] : false;

  return {
    client,
  };
};
